import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

import {Box, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Logout01Icon} from "@hugeicons/core-free-icons";
import {getPalette, hexToRgba, NODE_RADIUS, NODE_SHADOW} from "./nodeTheme";


function EndNode({ id, data, selected }) {

    const {name} = data;
    const palette = getPalette("end");

    return (
        <Box className={"end-node node"} sx={{
            width: "auto",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            px: 1, py: 0.6,
            borderRadius: `${NODE_RADIUS}px`,
            border: "1px solid",
            borderColor: palette.border,
            boxShadow: selected ? `${NODE_SHADOW}, 0 0 0 3px ${hexToRgba(palette.accent, 0.35)}` : NODE_SHADOW,
            transition: "box-shadow .18s ease",
        }}>
            <Handle type="target" position={Position.Left} id={id} />
            <Box sx={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 18, height: 18, borderRadius: "6px",
                background: hexToRgba("#FFFFFF", 0.14), color: "#F1F5F9", flexShrink: 0,
            }}>
                <HugeiconsIcon icon={Logout01Icon} size={11} color={"#F1F5F9"} />
            </Box>
            <Typography noWrap sx={{fontSize: 10, fontWeight: 600, color: "#F1F5F9", letterSpacing: "0.01em"}}>
                {name || "End"}
            </Typography>
        </Box>
    );
}

export default memo(EndNode);
